import { render, staticRenderFns } from "./TournamentFloating.vue?vue&type=template&id=ccd64bb8&scoped=true"
import script from "./TournamentFloating.vue?vue&type=script&lang=js"
export * from "./TournamentFloating.vue?vue&type=script&lang=js"
import style0 from "./TournamentFloating.vue?vue&type=style&index=0&id=ccd64bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd64bb8",
  null
  
)

export default component.exports